import { render, staticRenderFns } from "./SecurityDeposits.vue?vue&type=template&id=52770ede&"
import script from "./SecurityDeposits.vue?vue&type=script&lang=js&"
export * from "./SecurityDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports